import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Apply persisted theme before first paint to avoid flash.
try {
  const t = localStorage.getItem("pmv5_theme");
  if (t === "dark" || t === "light") document.documentElement.setAttribute("data-theme", t);
  else document.documentElement.setAttribute("data-theme", "light");
} catch (_) { document.documentElement.setAttribute("data-theme", "light"); }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
